import { planTypes } from '@/common/constants';

export const localNumberCountryList = [
  {
    region: 'US',
    label: 'US',
    disabled: false,
  }, {
    region: 'CA',
    label: 'CA',
    disabled: false,
  },
];

export const tollFreeNumberCountryList = [{ region: 'US', label: 'US & CA', disabled: false }];

export const vanityLetter2NumberMap = new Map([
  ['A', 2],
  ['B', 2],
  ['C', 2],
  ['D', 3],
  ['E', 3],
  ['F', 3],
  ['G', 4],
  ['H', 4],
  ['I', 4],
  ['J', 5],
  ['K', 5],
  ['L', 5],
  ['M', 6],
  ['N', 6],
  ['O', 6],
  ['P', 7],
  ['Q', 7],
  ['R', 7],
  ['S', 7],
  ['T', 8],
  ['U', 8],
  ['V', 8],
  ['W', 9],
  ['X', 9],
  ['Y', 9],
  ['Z', 9],
]);

export const vanityNumber2LetterMap = new Map([
  ['2', ['A', 'B', 'C']],
  ['3', ['D', 'E', 'F']],
  ['4', ['G', 'H', 'I']],
  ['5', ['J', 'K', 'L']],
  ['6', ['M', 'N', 'O']],
  ['7', ['P', 'Q', 'R', 'S']],
  ['8', ['T', 'U', 'V', 'W']],
  ['9', ['X', 'Y', 'Z']],
]);

export const PBX_REGIONS = {
  US_AND_CANADA: 'US',
  AUS_AND_NZ: 'AU',
  UK_AND_IRELAND: 'UK',
  GLOBAL: 'GLOBAL',
  JP:'JP',
};

export const PBX_GLOBAL = {
  GS: 'GS',
};

export const PBX_DIVISIONS = {
  CA: 'CA',
  PRO: 'PRO'
};

export const PBX_GS =['ZSM','ZSU','ZSD','ZGT']

export const PBX_DIVISION_KEYS = ['CA','PRO']

export const PBX_REGIONS_MAP_COUNTRY = {
  'US': [PBX_REGIONS.US_AND_CANADA, 'CA'],
  'AU': [PBX_REGIONS.AUS_AND_NZ, 'NZ'],
  'UK': [PBX_REGIONS.UK_AND_IRELAND, 'IE'],
  'JP': [PBX_REGIONS.JP, 'JP'],
}

export const PBX_REGIONS_MAP_CATEGORY = {
  [PBX_REGIONS.AUS_AND_NZ]: ['pbx_ZAM', 'pbx_ZAU'],
  [PBX_REGIONS.JP]: ['pbx_ZJU', 'pbx_ZJM'],
  [PBX_GLOBAL.GS]: ['pbx_ZSM','pbx_ZSU','pbx_ZSD','pbx_ZGT'],
}

export const defaultCountryIsoCode = 'US';
export const defaultTollFreePrefix = '888';
export const maxSelectPhoneNumbers = 10;

export const supportTollFreePrefixList = ['833', '844', '855', '866', '877', '888'];

export const numberRegExp = /^[0-9]*$/;

export const phoneNumberTypeMap = {
  local: 'local',
  tollFree: 'toll-free',
  portNumber: 'port-number',
};

export const regions = [
  { key: PBX_REGIONS.US_AND_CANADA, label: 'billing.pbx.regions.US', desc: 'billing.pbx.calling_plans_US_Canada' },
  { key: PBX_REGIONS.UK_AND_IRELAND, label: 'billing.pbx.regions.UK', desc: 'billing.pbx.calling_plans_UK_Ireland' },
  { key: PBX_REGIONS.AUS_AND_NZ, label: 'billing.pbx.regions.AUS', desc: 'billing.pbx.calling_plans_AUS_NZ'  },
  { key: PBX_REGIONS.JP, label: 'billing.pbx.regions.JP', desc: 'billing.pbx.calling_plans_JP'  },
]

export const divisions = [
  { key: PBX_DIVISIONS.CA, label: 'billing.pbx.divisions.CA', desc: 'billing.pbx.calling_plans_CA' ,category:'ZCA' },
  { key: PBX_DIVISIONS.PRO, label: 'billing.pbx.divisions.PRO', desc: 'billing.pbx.calling_plans_PRO' ,category:'ZPP' },
]

export const pbxGlobalSelect = [
  { category:'ZSM', key:'GS',label: 'billing.pbx.global_select', desc: 'billing.pbx.calling_plans_Global_Select',},
  { category:'ZSU', key:'GS',label: 'billing.pbx.global_select', desc: 'billing.pbx.calling_plans_Global_Select'},
  { category:'ZSD', key:'GS',label: 'billing.pbx.global_select', desc: 'billing.pbx.calling_plans_Global_Select'},
  { category:'ZGT', key:'GS',label: 'billing.pbx.global_select', desc: 'billing.pbx.calling_plans_Global_Select'},
]


export const phonePlanUnitMap = {
  [planTypes.ZOOM_PHONE$ZPA]: 'billing.planform.unit.user',
  [planTypes.ZOOM_PHONE$ZPI]: 'billing.planform.unit.license'
}

export const UnconfigCallingPlanCategory = ['pbx_common_area','pbx_feature_pro']
